import * as actions from 'actions';

const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.AUTH_UPDATE: {
      const { user: omit, ...withoutUser } = action.authData; // eslint-disable-line no-unused-vars
      return withoutUser;
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/auth/reducer.js
 **/